import React from 'react';
import { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export const IconLeft = ({ classProps }: PropsWithClassProps) => {
  return (
    <svg
      className={twMerge('h-4 w-4', classProps?.root)}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 3.00012L5 7.00012L9 11.0001" stroke="currentColor" />
    </svg>
  );
};
